import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const LightIcon: FunctionComponent<SvgIconProps> = (props) => {
	return <LightbulbOutlinedIcon {...props} />;
};

export default LightIcon;